import React from "react";
import * as moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import {
  appendDeletionArray,
  subtractDeletionArray,
  changeCampaignsModal,
  setViewEmailDisplay,
} from "../../../../../../redux/actions/campaigns";
import {
  ChangeIconButton,
  DeleteIconButton,
  InfoTableButton,
  ViewIconButton,
} from "../../../../../library/button";
import { Checkbox } from "../../../../../library/checkbox";

const Index = ({ singleSms, index, arr }) => {
  const dispatch = useDispatch();
  const deletions = useSelector((state) => state.campaigns.deletionArray);

  const activeCompany = useSelector(
    (state) => state.activeCompany && state.activeCompany.activeCompany
  );

  const clickViewEmail = (snapshot) => {
    if (activeCompany.subscription) {
      dispatch(changeCampaignsModal({ viewEmailModal: true }));
      dispatch(setViewEmailDisplay(snapshot));
    }
  };

  return (
    <tr key={singleSms.id} className={index === arr.length - 1 && "last"}>
      <td className="content-preview">
        <span className="preview">{singleSms.snapshot}</span>
      </td>
      <td>{singleSms.sender}</td>
      <td className="industry-label">
        <InfoTableButton color="blue" title={singleSms.reach} />
      </td>
      <td>{singleSms.addedBy}</td>
      <td>{moment.unix(singleSms.timestamp).format("HH:MM DD/MM/YYYY")}</td>
    </tr>
  );
};

export default Index;
